import { Link } from '@tanstack/react-router'
import { Row } from '@tanstack/react-table'
import { IconListCheck } from '@tabler/icons-react'
import { Edit, Eye } from 'lucide-react'
import { FnsServiceSurveyGqlOutput } from 'zma-react-sdk/fns-service'
import { useTranslation } from '@/hooks/use-translation'
import { Button } from '@/components/ui/button'
import { useFnsMode } from '@/features/forms-and-surveys/hooks'

interface FnsActionsCellProps {
  row: Row<FnsServiceSurveyGqlOutput>
}

export function FnsActionsCell({ row }: FnsActionsCellProps) {
  const mode = useFnsMode()
  const { t } = useTranslation()
  const data = row.original

  const isSurvey = mode === 'survey'
  const capitalizedMode = mode.charAt(0).toUpperCase() + mode.slice(1)

  const viewRoute = isSurvey ? '/surveys/$surveyId' : '/forms/$formId'
  const editRoute = isSurvey ? '/surveys/$surveyId/edit' : '/forms/$formId/edit'
  const routeParams = isSurvey ? { surveyId: data.id } : { formId: data.id }

  return (
    <div className='flex items-center gap-2'>
      <Button variant='ghost' size='sm' asChild className='h-8 w-8 p-0'>
        <Link
          to={viewRoute}
          params={routeParams}
          title={t(`${mode}s.view${capitalizedMode}Detail`)}
        >
          <Eye className='h-4 w-4' />
        </Link>
      </Button>
      <Button
        variant='ghost'
        size='sm'
        asChild
        className='h-8 w-8 p-0'
        title={t(`${mode}s.edit${capitalizedMode}Detail`)}
      >
        <Link to={editRoute} params={routeParams}>
          <Edit className='h-4 w-4' />
        </Link>
      </Button>
      <Button variant='ghost' size='sm' asChild className='h-8 w-8 p-0'>
        <Link
          to={'/fns-responses'}
          search={{ mode, id: data.id, name: data.title || '' }}
          title={t(`${mode}s.view${capitalizedMode}Responses`)}
        >
          <IconListCheck className='h-4 w-4' />
        </Link>
      </Button>
    </div>
  )
}
